import React from "react";
import Modal from "components/ui/modal";
import { Button } from "components/ui_new/index";
import { Close } from "@mui/icons-material";
import useTranslate from "hooks/use-translate-language";
import { Spinner } from "components/ui";
import propTypes from "prop-types";
import { IconButton } from "@mui/material";

const ConfirmationModal = ({
  buttonText,
  title,
  message,
  onYes,
  spinner,
  ariaLabelledBy,
  mobileCard = false
}) => {
  const translate = useTranslate();

  const submit = closeModal => {
    onYes(closeModal);
  };

  return (
    <Modal
      maxWidth="sm"
      fullWidth
      renderTrigger={({ openModal }) => (
        <Button
          variant="outlined"
          className={`${mobileCard ? "mobile-secondary-button" : ""}`}
          color="primary"
          id="reschedule-button"
          onClick={() => {
            openModal();
          }}
          style={{
            width: "100%",
            maxWidth: mobileCard ? "100%" : "15rem",
            minWidth: mobileCard ? "auto" : "10rem"
          }}
          aria-labelledby={ariaLabelledBy}
        >
          {translate(buttonText)}
        </Button>
      )}
      renderContent={({ closeModal }) => (
        <div
          className="reschedule-chat-modal-container"
          style={{
            padding: "2rem",
            position: "relative"
          }}
        >
          <IconButton
            onClick={closeModal}
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              minWidth: "auto",
              padding: "8px"
            }}
            size="small"
            type="button"
            aria-label={translate("close")}
          >
            <Close aria-hidden="true" />
          </IconButton>
          <h2 style={{ marginBottom: "2rem" }}>{translate(title)}</h2>
          <span style={{ fontSize: "1.2rem" }}>{translate(message)}</span>

          <div
            style={{
              textAlign: "center",
              marginTop: "3rem",
              display: "flex",
              justifyContent: "center",
              gap: "1rem"
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              id="no-button"
              onClick={() => closeModal()}
              style={{
                width: "100%",
                maxWidth: "10rem",
                minWidth: "5rem"
              }}
            >
              No
            </Button>

            {!spinner && (
              <Button
                variant="contained"
                color="primary"
                id="yes-button"
                onClick={() => {
                  submit(closeModal);
                }}
                style={{ width: "100%", maxWidth: "10rem", minWidth: "5rem" }}
              >
                {translate("yes")}
              </Button>
            )}
            {spinner && <Spinner style={{ display: "inline-block" }} />}
          </div>
        </div>
      )}
    />
  );
};

ConfirmationModal.propTypes = {
  buttonText: propTypes.string,
  title: propTypes.string,
  message: propTypes.string,
  onYes: propTypes.func,
  spinner: propTypes.bool,
  ariaLabelledBy: propTypes.string
};

export default ConfirmationModal;
